module.exports = __webpack_public_path__ + "img/surplus.png";